




























































import Component from "vue-class-component";
import VueRecaptcha from "vue-recaptcha";
import {CodeApi, ImageApi, ImageCollectionDto} from "@swagger";
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {
    VueRecaptcha
  }
})
export default class CodeSubmission extends BasicComponent {

  codes: string[] = [""];
  loading: boolean = false;
  errorMessage: string | null = null;
  valid: boolean[] = [];
  errors: string[] = [];
  codeImportCounter: number = 0; // Whenever the codes are imported from the URL query parameters, this counter is increased so that the for loop in the template updates reactively.

  created() {
  }

  mounted() {
    if (this.$store.getters.step === "1") {
      this.trackPage("Code-Eingabe");
    }
    this.$nextTick(() => {
      if (this.$store.getters.step == 1) {
        if (this.$route.query.codes) {
          this.codes = String(this.$route.query.codes).split(",");
          this.codeImportCounter++;
          for (let i = 0; i<this.codes.length; i++) {
            this.onCodeChanged(i);
          }
        }
      }
    });
  }

  executeCaptcha() {
    this.$refs.captcha["execute"]();

  }

  get mayAddCode() {
    return this.codeValid(this.codes[this.codes.length - 1]);
  }

  addCode() {
    this.codes.push("");
    this.errors.push(null);
    this.valid.push(null);
    this.trackEvent("Code", "Hinzufügen");
  }

  removeCode(id) {
    this.codes.splice(id, 1);
    this.errors.splice(id, 1);
    this.valid.splice(id, 1);
  }

  /**
   * Ignores empty codes, but needs at least one non-empty value
   */
  get allCodesValid() {
    const codes = this.codes;
    const isValid = (it, index) => {
      return (this.codeValid(it) && !this.errors[index]);
    }
    if (!codes.every((it, index) => {
      return !this.hasText(it) || isValid(it, index);
    })) {
      return false;
    }
    return codes.filter(isValid).length > 0;
  }

  hasText(str: string): boolean {
    return str != null && str.trim().length > 0;
  }

  codeValid(code) {
    return code.length > 0;
  }

  onCodeChanged(id) {
    let code = this.codes[id];
    code = code.split("-").join(""); // Remove '-'
    let newCode = "";
    for (let i = 0; i < code.length; i++) {
      const char = code.charAt(i);
      if (!"abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".includes(String(char))) continue;
      newCode += char;
    }
    code = newCode;
    newCode = "";
    for (let i = 0; i < code.length; i++) {
      newCode += code.charAt(i);
      if (i % 3 == 2 && i < code.length - 1) {
        newCode += "-";
      }
    }

    this.$set(this.codes, id, newCode);

    this.errors[id] = null;
    this.valid[id] = null;
  }

  start(captchaToken: string) {
    this.errorMessage = null;
    this.$refs.captcha["reset"]();

    this.trackEvent("Code", "Eingelöst");
    const codes = this.codes.filter(c => this.hasText(c));
    new CodeApi(this.apiConfiguration).redeemCodes({codes: codes}, captchaToken)
        .then((data: boolean[]) => {
          this.valid = data;
          if (data.every(it => it)) {
            this.errors = [];
            new ImageApi(this.apiConfiguration).getImages()
                .then((data: ImageCollectionDto) => {
                  this.$store.commit("setImageSelection", data);
                  this.setStep(2);
                  this.requestProducts();
                  this.requestCoupons();
                  this.checkIfNewsletterAccepted((accepted) => {
                    if (!accepted) {
                      this.$store.commit("setNewsletterDialogOpen", true);
                    }
                  });
                  this.trackEvent("Code", "Eingelöst");
                })
          } else {
            this.errors = data.map(successful => {
              if (successful) return null;
              else return this.$t("CODE_INVALID").toString();
            })
          }
        })
        .catch((err) => {
          err.json().then(error => {
            this.errorMessage = error.message;
            console.log(error);
          });
        });
  }

};
